import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import FilterSystemsPopUpMenu from './FilterSystemsPopUpMenu';
import { Store } from 'store/storeTypes';
import {
  toggleFilterRowSystemsSelection,
  toggleFilterModelRowSystemsSelection,
  toggleFilterSerialRowSystemSelection,
  toggleAllSystemsSelection,
  singlePrinterSelection,
} from '../../actions/reportFilterActions';

import {
  currentSystemsSelector,
  filterDataBySystemGroupSelector,
  filteredCurrentSystemsSelector,
  filteredSitesSelector,
  filteredSystemSelector,
  filterStateBySystemGroupSelector,
  filterValueSelector,
  fitleredModelsSelector,
  historicalSystemsToRenderSelector,
  selectedCurrentSystemsCountSelector,
} from 'selectors/filterStateDataSelectors';
import { systemGroupSelector } from 'reducers/ui/systemGroupUiReducer';
import { activeReportSelector } from 'reducers/reports/filterDataReducer';
import { isOverviewProductionModeSelector } from 'reducers/ui/timeViewModeUiReducer';
import { sitesWithProductionHoursSetSelector } from 'reducers/productionHoursApiReducer';

export interface OwnProps {
  pbiReportHeight?: number;
  isMobile?: boolean;
}

const mapStateToProps = (state: Store) => {
  return {
    selectedSystemGroup: systemGroupSelector(state),
    filterData: filterDataBySystemGroupSelector(state),
    filterState: filterStateBySystemGroupSelector(state),
    filterValue: filterValueSelector(state),
    filteredSite: filteredSitesSelector(state),
    filteredModel: fitleredModelsSelector(state),
    filteredSystem: filteredSystemSelector(state),
    currentSystems: currentSystemsSelector(state),
    filteredCurrentSystems: filteredCurrentSystemsSelector(state),
    historicalSystemsToRender: historicalSystemsToRenderSelector(state),
    selectedCurrentSystemsCount: selectedCurrentSystemsCountSelector(state),
    activeReport: activeReportSelector(state),
    isProductionMode: isOverviewProductionModeSelector(state),
    sitesWithProductionHoursSet: sitesWithProductionHoursSetSelector(state),
  };
};
const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      toggleFilterRowSystemsSelection,
      toggleFilterModelRowSystemsSelection,
      toggleFilterSerialRowSystemSelection,
      toggleAllSystemsSelection,
      singlePrinterSelection,
    },
    dispatch
  );

export type IOverviewProps = OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(FilterSystemsPopUpMenu);
